blue.ready('spotlight-banner-multi', '.spotlight-banner-multi', sbm => {
    const spotlights = [...sbm.querySelectorAll('.spotlight')]
    let active = window.localStorage.getItem(`spotlight_rotator${sbm.getAttribute('id')}`) || -1
    if (active == -1) {
        window.localStorage.setItem(`spotlight_rotator${sbm.getAttribute('id')}`, ++active)
    }
    else if (active == spotlights.length) {
        active = 0
    }
    spotlights[active].classList.add('is-active')
    window.localStorage.setItem(`spotlight_rotator${sbm.getAttribute('id')}`, ++active)

    // ***** add indicators *****
    let indicators = sbm.querySelector('.spotlight-banner-multi-indicators')
    spotlights.forEach(function (item, index) {
        //-console.log(item, index);
        index = index + 1
        if(active === index) {
            indicators.innerHTML += "<div class='spotlight-banner-multi-indicators-item is-active' id='idicator-" + index + "'></div>"
        }
        else {
            indicators.innerHTML += "<div class='spotlight-banner-multi-indicators-item' id='idicator-" + index + "'></div>"
        }
    });

    // ***** add event listeners to indicators *****
    const indicatorItems = [...sbm.querySelectorAll('.spotlight-banner-multi-indicators-item')]
    indicatorItems.forEach(function (item, index) {
        item.addEventListener("click", function(){
            if (active !== (index + 1)) {
                spotlights.forEach(function (item) {
                    item.classList.remove('is-active')
                })
                spotlights[index].classList.add('is-active')
                indicatorItems.forEach(function (item) {
                    item.classList.remove('is-active')
                })
                item.classList.add('is-active')
                active = index + 1
            }
        });
    });
    
}) 